import SecureBaseModel from './SecureBaseModel';

class ControlModel extends SecureBaseModel {

    //These have to match with the routes in backend > APIController
    static GET_ALL_CONTROLS = 'control-settings';
    static GET_CONTROLLER_DETAILS = 'control-setting-details';
    static UPDATE_CONTROL_STATUS = 'update-controller-status';

    constructor() {
        super();
    }

    // params { custId: value, itemId: value }
    async getAllControlSettings() {
        return await this.getData(ControlModel.GET_ALL_CONTROLS, {});
    }

    // params { controlCode: value , name: value}
    async getControlSettingDetails(params) {
        return await this.postData(ControlModel.GET_CONTROLLER_DETAILS, params);
    }

    // params {id: value, name: value, description: value, controlCode: value, redirect: value, status: value, updatedBy: value}
    async updateControllerStatus(params) {
        return await this.postData(ControlModel.UPDATE_CONTROL_STATUS, params);
    }
}

export default ControlModel;
